import {Validator} from '@/type/validation/result';
import {集計種別型} from '@/type/stock/inhospital/types';
import { 在庫商品区分型 } from '@/type/stock/item';
import {半角カナ禁止, 年月書式, 必須入力} from '@/type/validation/validator';

export interface 院内総在庫場所型 {
  部署コード: string;
  部署名: string;
}

export interface 院内総在庫照会ヘッダー型 {
  集計種別: 集計種別型;
  在庫場所: 院内総在庫場所型;
  在庫年月: string;
}

export interface 院内総在庫照会明細型 {
  在庫場所: 院内総在庫場所型;
  商品コード: string;
  商品区分: string;
  使用区分: string;
  メーカー名: string;
  在庫商品名: string;
  規格容量: string;
  単位: string;
  在庫数: number;
  在庫金額: number;
  薬価金額: number;
}

export interface 院内総在庫照会結果型 {
  ヘッダー: 院内総在庫照会ヘッダー型;
  明細一覧: 院内総在庫照会明細型[];
  アラートメッセージ: string;
}

export class 院内総在庫照会検索条件型 {
  constructor(public 集計種別: 集計種別型|null = null,
              public 在庫場所: string = '',
              public 在庫年月: string = '',
              public メーカー名検索条件: string = '',
              public 商品名カナ検索条件: string = '',
              public 商品区分検索条件: 在庫商品区分型|null = null,
              public 使用区分検索条件: string|null = null,
  ) {}
}

export const 院内総在庫照会検索条件型バリデータ一覧: Validator[] = [
  {
    name: '在庫年月',
    constraints: [
      {method: 必須入力, message: '在庫年月を入力してください'},
      {method: 年月書式, message: '在庫年月の書式が不正です'},
    ],
  },
  {
    name: '商品名カナ検索条件',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];
